import { render, staticRenderFns } from "./OrderDetailsSkuList.vue?vue&type=template&id=4fae175e&scoped=true&"
import script from "./OrderDetailsSkuList.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsSkuList.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsSkuList.vue?vue&type=style&index=0&id=4fae175e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae175e",
  null
  
)

export default component.exports